import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import ImageUploader from '../../components/admin/ImageUploader';

export default function ServicesManager() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  const initialServices = [
    {
      id: 'kat-karsiligi',
      icon: 'ri-building-4-line',
      title: 'Kat Karşılığı İnşaat',
      image: '/yapsat-site-5.png',
      description: 'KARE YAPI olarak, arsa sahiplerine en kârlı, güvenilir ve modern yaşam alanlarını sunmak için kat karşılığı inşaat projeleri üretiyoruz. Arsanızın konumuna, imar durumuna ve çevresel dinamiklere en uygun mimari projeyi titizlikle hazırlıyor, projelendirmeden anahtar teslime kadar tüm inisiyatifi ve finansal yükü üstleniyoruz. Kaliteden ödün vermeden, güncel deprem yönetmeliklerine %100 uygun, estetik ve sağlam binalar inşa ederek, arsanızın değerine değer katıyoruz.'
    },
    {
      id: 'kentsel-donusum',
      icon: 'ri-home-heart-line',
      title: 'Kentsel Dönüşüm',
      image: '/yapsat-realistic-1.png',
      description: 'Riskli binalarınızı, aileniz ve geleceğiniz için güvenli, modern ve yüksek standartlı yaşam alanlarına dönüştürüyoruz. Kentsel dönüşüm sürecindeki tüm yasal prosedürleri, ruhsat alım işlemlerini ve projelendirmeyi sizin adınıza hızlıca tamamlıyoruz. Sadece bir bina yenilemekle kalmıyor; otoparklı, peyzajlı, yüksek yalıtımlı ve prestijli yapılar ortaya çıkararak yaşam kalitenizi zirveye taşıyoruz. Süreci en şeffaf şekilde yürüterek mağduriyete yer bırakmıyoruz.'
    },
    {
      id: 'taahhut-proje',
      icon: 'ri-tools-line',
      title: 'Taahhüt ve Güçlendirme',
      image: '/tk-const-new-1.png',
      description: 'Deneyimli mühendis ve mimar kadromuzla, kamu ve özel sektör projelerinde ana yüklenici olarak taahhüt hizmetleri veriyoruz. Konut komplekslerinden ticari alanlara kadar geniş bir yelpazede üstlendiğimiz projeleri; iş güvenliği kurallarından taviz vermeden, taahhüt edilen bütçe sınırları içinde ve tam zamanında teslim ediyoruz. Aynı zamanda mevcut yapılarınızın sismik performans analizlerini yaparak modern donatılarla depreme karşı kesin güçlendirme çözümleri sunuyoruz.'
    },
    {
      id: 'mimari-muhendislik',
      icon: 'ri-compasses-2-line',
      title: 'Mimari ve Mühendislik Tasarımı',
      image: '/tk-int-ref-1.png',
      description: 'İnşaat öncesi asıl katma değerin tasarımda olduğuna inanıyoruz. KARE YAPI tasarım ofisinde; estetik, fonksiyonellik ve enerji verimliliğini merkeze alan yenilikçi konseptler üretiyoruz. Statik, mimari, mekanik ve elektrik projelerini bütünleşik bir mühendislik yaklaşımıyla çözüyor, güncel inşaat teknolojileri kullanarak hata payını sıfıra indiriyoruz. Hayalinizdeki yapıyı önce kağıt üzerinde kusursuzca var ediyoruz.'
    },
    {
      id: 'anahtar-teslim',
      icon: 'ri-key-2-line',
      title: 'Anahtar Teslim Projeler',
      image: '/premium-project-block.png',
      description: '\'Siz hayal edin, biz teslim edelim\' prensibiyle, projenin ilk saha hafriyatından, evinize gireceğiniz o son saniyeye kadar tüm inşaat ve ince işçilik süreçlerini tek elden yönetiyoruz. Altyapı, temel atma, kaba inşaat, elektrik-su tesisatları, akıllı ev sistemleri, parke, seramik ve peyzaj... Bütünleşik bir kalite kontrol mekanizması ile sürdürülen projelerimizde, size sadece anahtarınızı alıp yeni ve kusursuz bir yaşama adım atmak kalıyor.'
    },
    {
      id: 'yatirim-danismanlik',
      icon: 'ri-line-chart-line',
      title: 'Gayrimenkul Yatırım Danışmanlığı',
      image: '/premium-project-v6.png',
      description: 'Piyasanın dinamiklerini yakından takip eden uzman kadromuzla, gayrimenkul yatırımlarınızı en yüksek getiriyle buluşturuyoruz. Arazi geliştirme, arsa alım-satımı, fizibilite çalışmaları ve konut projelerinde yatırım analizi yaparak sizi doğru lokasyona ve kârlı projelere yönlendiriyoruz. KARE YAPI\'nın yıllara dayanan bölgesel hakimiyeti sayesinde, birikimlerinizi riskten uzak, sağlam ve hızla değer kazanan yapılara dönüştürüyoruz.'
    }
  ];
  
  const [services, setServices] = useState(initialServices);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, 'pages', 'services');
        const snap = await getDoc(docRef);
        // Add auto-recovery condition: if id is a number (corrupted dummy data), overwrite it!
        if (snap.exists() && snap.data().items && snap.data().items.length > 0 && typeof snap.data().items[0].id === 'string') {
          const dbItems = snap.data().items.map((dbSvc: any) => {
            const defItem = initialServices.find(i => i.id === dbSvc.id);
            return {
              ...dbSvc,
              image: dbSvc.image || defItem?.image || ''
            }
          });
          setServices(dbItems);
          // Only merge new defaults if keys are missing
          await setDoc(docRef, { items: dbItems, updatedAt: new Date() }, { merge: true });
        } else {
          // Corrupted or empty -> Overwrite!
          await setDoc(docRef, { items: initialServices, updatedAt: new Date() }, { merge: true });
          setServices(initialServices);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleChange = (id: string, field: string, value: string) => {
    setServices(services.map(s => s.id === id ? { ...s, [field]: value } : s));
  };

  const handleSave = async () => {
    setSaving(true);
    setMessage('');
    try {
      const docRef = doc(db, 'pages', 'services');
      await setDoc(docRef, { items: services, updatedAt: new Date() }, { merge: true });
      setMessage('Hizmet kalemleri başarıyla güncellendi!');
      setTimeout(() => setMessage(''), 3000);
    } catch (err) {
      console.error(err);
      setMessage('Kayıt başarısız oldu.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-zinc-500">Yükleniyor...</div>;

  return (
    <div className="space-y-6 pb-24">
      <div className="mb-6">
        <h2 className="text-2xl font-black text-white uppercase tracking-widest" style={{ fontFamily: 'Raleway, sans-serif' }}>Hizmetlerimiz Yönetimi</h2>
        <p className="text-zinc-400 text-sm mt-1">Sitede dönerek açılan 6 hizmet kartının yazılarını değiştirin.</p>
      </div>

      {message && (
        <div className={`p-4 rounded-xl font-bold text-sm ${message.includes('başarısız') ? 'bg-red-500/10 text-red-500' : 'bg-green-500/10 text-green-500'}`}>
          {message}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {services.map((svc, index) => (
          <motion.div key={svc.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.1 }} className="bg-zinc-900 border border-zinc-800 rounded-2xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 rounded-full bg-red-600/10 text-red-500 flex items-center justify-center font-bold">{index + 1}</div>
              <h3 className="font-bold text-white uppercase tracking-wider">{svc.title}</h3>
            </div>
            
            <div className="space-y-4">
              <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                <div>
                  <label className="block text-zinc-400 text-xs font-bold mb-1 uppercase tracking-wider">Hizmet Başlığı</label>
                  <input type="text" value={svc.title} onChange={e => handleChange(svc.id, 'title', e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-2 px-4 focus:border-red-500 focus:outline-none" />
                </div>
                <div>
                  <label className="block text-zinc-400 text-xs font-bold mb-1 uppercase tracking-wider">İkon (Remix Icon Class)</label>
                  <input type="text" value={svc.icon} onChange={e => handleChange(svc.id, 'icon', e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 text-white rounded-xl py-2 px-4 focus:border-red-500 focus:outline-none" />
                </div>
              </div>
              <div>
                <label className="block text-zinc-400 text-xs font-bold mb-1 uppercase tracking-wider">Hizmet Açıklaması</label>
                <textarea value={svc.description} onChange={e => handleChange(svc.id, 'description', e.target.value)} rows={6} className="w-full text-justify bg-zinc-950 border border-zinc-800 text-zinc-300 rounded-xl py-3 px-4 focus:border-red-500 focus:outline-none leading-relaxed"></textarea>
              </div>
              <div className="pt-2">
                 <ImageUploader 
                   currentImageUrl={svc.image} 
                   onImageUploaded={(url) => handleChange(svc.id, 'image', url)} 
                   onImageDeleted={() => handleChange(svc.id, 'image', '')} 
                   folderPath={`pages/services/card_${svc.id}`}
                   label="Hizmet Arka Plan Görseli"
                 />
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* DEV KAYDET BUTONU */}
      <div className="fixed bottom-0 left-0 right-0 md:left-64 bg-zinc-950/80 backdrop-blur-lg border-t border-zinc-800 p-4 flex justify-end z-50">
         <button onClick={handleSave} disabled={saving} className="bg-red-600 hover:bg-red-700 text-white font-black text-lg py-4 px-12 rounded-xl shadow-2xl shadow-red-600/30 transition-all flex items-center gap-3 disabled:opacity-50">
           {saving ? <i className="ri-loader-4-line animate-spin"></i> : <i className="ri-save-3-line"></i>}
           HİZMETLERİ KAYDET VE YAYINLA
         </button>
      </div>
    </div>
  );
}
